<template>
  <f7-page class="main-contracts-page">
    <template #fixed>
      <TheNavbar
        nav-title="Contratos"
        back-btn-enable
        :style="appTheme"
      />
    </template>

    <div class="content-contracts-page-header padding padding-vertical-half">
      <div v-if="farmer != null">
        <div>{{ `${$t('common.farmer')}:` }}</div>
        <div>{{ farmer.name }}</div>
      </div>
      <div v-if="field != null">
        <div class="content-contracts-page-header__title">
          Finca:
        </div>
        <div class="content-contracts-page-header__info">
          {{ `${field.code} - ${field.name}` }}
        </div>
      </div>
    </div>

    <div class="padding-horizontal">
      <ContractsList :contracts="contracts" />
    </div>
  </f7-page>
</template>

<script>
import TheNavbar from '@/components/TheNavbar.vue';
import FieldService from '@/js/services/contracts/Fields';
import FarmerService from '@/js/services/contracts/Farmers';
import ContractService from '@/js/services/contracts/Contracts';
import ContractsList from '@/components/contracts/ContractsList.vue';

export default {
  name: 'ContractsPage',
  components: {
    TheNavbar,
    ContractsList,
  },
  props: {
    farmerId: { type: Number, default: 0 },
    fieldId: { type: Number, default: 0 },
  },

  data() {
    return {
      contracts: [],
      farmer: null,
      field: null,
    };
  },

  computed: {
    appTheme() {
      return {
        '--f7-navbar-bg-color': 'var(--his-dark-blue)',
        '--f7-navbar-text-color': '#fff',
      };
    },
  },

  async mounted() {
    await this.loadContracts();
  },

  methods: {
    async loadContracts() {
      let contracts = [];
      if (this.farmerId > 0) {
        contracts = await ContractService.getContractsByFarmer(this.farmerId);
        await this.loadFarmer();
      } else if (this.fieldId > 0) {
        contracts = await ContractService.getContractsByField(this.fieldId);
        await this.loadField();
      }

      this.contracts = contracts;
    },
    async loadFarmer() {
      this.farmer = await FarmerService.getById(this.farmerId);
    },
    async loadField() {
      this.field = await FieldService.getById(this.fieldId);
    },
  },
};
</script>

<style lang="scss">
.main-contracts-page {
  .page-content {
    background: var(--his-whispering-lilac);
  }

  .content-contracts-page-header {
    background-color: var(--his-oliva);

    >div {
      display: flex;
      align-items: center;
      color: #fff;
    }

    &__title {
      font-size: 14px;
      font-weight: 400;
    }

    &__info {
      font-size: 16px;
      font-weight: 500;
      padding-left: 10px;
    }
  }
}
</style>
